import { Button, ButtonVariants, Grid, type FormControlSizes } from '@talos/kyoko';

interface MarketDataCardActionButtonsProps {
  canSubmitOrder: boolean;
  canRequestRFQ: boolean;
  isRfqSupported: boolean;
  size: FormControlSizes;
  onClickBid: () => void;
  onClickRfq: () => void;
  onClickOffer: () => void;
}

export function MarketDataCardActionButtons({
  canSubmitOrder,
  canRequestRFQ,
  isRfqSupported,
  size,
  onClickBid,
  onClickRfq,
  onClickOffer,
}: MarketDataCardActionButtonsProps) {
  return (
    <Grid gridTemplateColumns="repeat(3, 1fr)" gap="spacing4" mb="spacing4">
      <Button
        disabled={!canSubmitOrder}
        onClick={onClickBid}
        variant={ButtonVariants.Default}
        size={size}
        data-testid="market-card-bid-button"
      >
        Bid
      </Button>
      <Button
        disabled={!isRfqSupported || !canRequestRFQ}
        onClick={onClickRfq}
        variant={ButtonVariants.Default}
        size={size}
        data-testid="market-card-rfq-button"
      >
        RFQ
      </Button>
      <Button
        disabled={!canSubmitOrder}
        onClick={onClickOffer}
        variant={ButtonVariants.Default}
        size={size}
        data-testid="market-card-offer-button"
      >
        Offer
      </Button>
    </Grid>
  );
}
